import { useLayoutEffect, useRef, useState } from 'react';
import { Transition } from 'react-transition-group';

const duration = 300;

const defaultStyle = {
    transition: `all ${duration}ms ease-in-out`,
    opacity: 0,
    transform: 'translateY(-15px)',
};

const createTransitionStyles = disableSlideAnimation => ({
    entering: { opacity: 1, transform: 'none' },
    entered: { opacity: 1, transform: 'none' },
    exiting: { opacity: 0, transform: disableSlideAnimation ? 'none' : 'translateY(-15px)' },
    exited: { opacity: 0, transform: disableSlideAnimation ? 'none' : 'translateY(-15px)' },
});

type Props = {
    in?: boolean;
    onEnter?: () => void;
    onExited?: () => void;
    disableSlideAnimation?: boolean;
};

const Fade: React.FC<Props> = ({
    children,
    in: inProp,
    onEnter,
    onExited,
    disableSlideAnimation = false,
}) => {
    const [inState, setInState] = useState(false);
    const transitionStyles = createTransitionStyles(disableSlideAnimation);
    const nodeRef = useRef(null);
    useLayoutEffect(() => {
        setInState(true);
    }, []);

    return (
        <Transition
            nodeRef={nodeRef}
            in={inState && inProp}
            timeout={duration}
            onEnter={onEnter}
            onExited={onExited}
        >
            {state => (
                <div
                    ref={nodeRef}
                    style={{
                        ...defaultStyle,
                        ...transitionStyles[state],
                    }}
                >
                    {children}
                </div>
            )}
        </Transition>
    );
};

export default Fade;
